export default __webpack_public_path__ + "static/media/activity-4.5ab9d12a.png";